import React from 'react';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { S3_MP4_URL } from '../../../../constants';

import styles from '../../CircleBlock.scss';

const FirstCircle = () => {
  const { isDesktop } = useLayoutContext();

  return (
    <div id="circle-1" className={styles.circleBlock}>
      <h2 className={styles.title} id="circle-1-title">
        {isDesktop ? (
          <div className={styles.titleWrapper}>
            <FadeIn animationRepeat>
              <span>Wander the world</span>
            </FadeIn>
            <FadeIn delay={1} animationRepeat>
              <span className={styles.titleThin}>and collect unique rewards</span>
            </FadeIn>
          </div>
        ) : (
          <FadeIn animationRepeat>
            <span>Wander the world</span>
            <br />
            <span className={styles.titleThin}>and collect unique rewards</span>
          </FadeIn>
        )}
      </h2>

      <video autoPlay preload="auto" loop muted playsInline className={styles.circle}>
        <source src={`${S3_MP4_URL}achievement_cover.mp4`} type="video/mp4" />
      </video>
    </div>
  );
};

export default FirstCircle;
